import React from 'react';
import { Image, Text, View } from 'react-native-web';
import { img_close } from '../../../../utils/ImagesManagementUtils';
import { textPrimary_14_0, textSecondary_9_3 } from '../TextComponent/TextStyle';

//= ========================================================================
const OnBoardingTopTitlesIOS = ({
  globJSON,
  simPlatform,
  subTitle,
  Title,
  withoutExtraHeight,
}) => {
  const { colors } = globJSON.configurations.theme;

  const myStyles = {
    imgCloseStyle: {
      width: 28,
      height: 28,
      marginLeft: 203,
      marginTop: withoutExtraHeight ? 46 : 26,
      tintColor: colors.tertiary_icons_color,
    },
    subTitleStyle: {
      marginLeft: 19,
      marginBottom: 14,
    },
    TitleStyle: {
      marginLeft: 19,
      width: 191,
      height: 32,
    },
  };

  return (
    <View>
      <Image
        fadeDuration={0}
        style={myStyles.imgCloseStyle}
        source={img_close}
      />
      <Text style={[textSecondary_9_3(globJSON, simPlatform), myStyles.subTitleStyle]}>
        {subTitle}
      </Text>
      <Text style={[textPrimary_14_0(globJSON, simPlatform), myStyles.TitleStyle]}>
        {Title}
      </Text>
    </View>

  );
};

export default OnBoardingTopTitlesIOS;
